/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The C2 gap-predicate token that excluded these orders (same rule as the daily reconciliation).
 * @export
 * @enum {string}
 */

export enum PeriodBackfillExclusionReason {
    NotPaid = 'NOT_PAID',
    BeforeAnchor = 'BEFORE_ANCHOR',
    C3Owned = 'C3_OWNED',
    ChannelExempt = 'CHANNEL_EXEMPT',
    AlreadyInvoiced = 'ALREADY_INVOICED',
    AwaitingMerchantInput = 'AWAITING_MERCHANT_INPUT',
    DeclinedByMerchant = 'DECLINED_BY_MERCHANT'
}



